import { Injectable } from '@angular/core';

@Injectable()
export class OdometroHorimetroService {

    constructor(

    ) { }

    setMask(value: string) {
        if (value) {
            value = value.toString();
            value = value.replace(/\D/g, '');
            value = value.replace(/(\d{0,})(\d{1})/, "$1.$2");
        } else {
            value = '';
        }
        return value;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/odometros-horimetros/shared/odometro-horimetro.service.ts
 **/